module.exports = __webpack_public_path__ + "static/media/QL_LOGOAsset 2Logo.1a2ede55.svg";